export const Bio = {
  name: "Ahmed Safta",
  roles: ["DevOps engineer","Cyber Security Enthusiast"],
  description: "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/AhmedSafta71",
  resume: "https://drive.google.com/file/d/1ccY9EZRPKpT3yEReaRR_hY3QvmzDpPpG/view?usp=sharing",
  linkedin: "www.linkedin.com/in/safta-ahmed-094a6321a",
  // Medium: "https://medium.com/@ahmedsafta71",
  insta: "https://www.instagram.com/safta.ahmed/",
  facebook: "https://www.facebook.com/ahmed.safta.7",
}


export const skills = [
  {
    title: 'Plateforms & Tools',
    skills: [
      {
        name: 'Openstack',
        image: 'https://images.seeklogo.com/logo-png/45/1/openstack-logo-png_seeklogo-458267.png',
      },
      {
        name: 'Terraform',
        image: 'https://static-00.iconduck.com/assets.00/file-type-terraform-icon-455x512-csyun60o.png',
      },
      {
        name: 'Wazuh',
        image: 'https://wazuh.com/uploads/2022/05/WAZUH.png',
      },
      {
        name: 'Thehive',
        image: 'https://miro.medium.com/v2/format:webp/0*Q4DUcqqBUADtuRLJ',
      },
      {
        name: 'Shuffle',
        image: 'https://shuffler.io/images/Shuffle_logo.png',
      },
      {
        name: 'Nexus',
        image: 'https://cdn.prod.website-files.com/5f10ed4c0ebf7221fb5661a5/5f2af61146c55b6e172fa5b3_NexusRepo_Icon.png'
      },
      {
        name: 'Jenkins',
        image: 'https://upload.wikimedia.org/wikipedia/commons/e/e9/Jenkins_logo.svg',
      },
      {
        name: 'SonarQube',
        image: 'https://cdn.worldvectorlogo.com/logos/sonarqube-1.svg',
      },
      {
        name: 'Vagrant',
        image: 'https://upload.wikimedia.org/wikipedia/commons/8/87/Vagrant.png',
      },
      {
        name: 'Docker',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRCAJH4R87uV3Rvncs3L3urjeNESAfJGTMTrA&s',
      },
      {
        name: 'Kubernetes',
        image: 'https://juststickers.in/wp-content/uploads/2018/11/kubernetes-wordmark.png',
      }, 
      {
        name: 'Git',
        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Git_icon.svg/2048px-Git_icon.svg.png',
      },
  
      {
        name: 'Bitbucket',
        image: 'https://static-00.iconduck.com/assets.00/bitbucket-icon-454x512-57v0di9k.png',
      },
      {
        name: 'Jira',
        image: 'https://static-00.iconduck.com/assets.00/jira-icon-2048x2048-nmec2job.png',
      },
   
    ],
  },
  {
    title: 'Amazon Web Services',
    skills: [
      {
        name: 'AWS Lambda',
        image: 'https://upload.wikimedia.org/wikipedia/commons/5/5c/Amazon_Lambda_architecture_logo.svg',
      },
      {
        name: 'AWS Step Functions',
        image: 'https://cdn.prod.website-files.com/60f955236a773f743298d63b/6148e736908efd816f7d4a2d_16yq8ybul2Pvu4cgJbVCCszAKD93ku3HDUvf5Iyaj3swdzWt626_2alUm1L9lCRd2yienu6clcde2f_XOFwbf2eDX70BV-piIL9qH-igHyYUbUQsiRNbYIDDP8VTElOSW4TSF6c8%3Ds0.png'
      },
      {
        name: 'Amazon DMS',
        image: 'https://cloud-icons.onemodel.app/aws/Architecture-Service-Icons_01312023/Arch_Database/64/Arch_AWS-Database-Migration-Service_64.svg',
      },
      {
        name: 'Amazon ECS',
        image: 'https://d3g9o9u8re44ak.cloudfront.net/logo/5cd326ff-a018-4472-b384-15142bfe5d2c/4862aa6a-08fc-4290-b05e-3012c4e57a92.png',
      },
      {
        name: 'AWS RDS',
        image: 'https://help.sumologic.com/img/integrations/amazon-aws/rds.png',
      },
    
      {
        name: 'EFS',
        image: 'https://seeklogo.com/images/A/amazon-elastic-file-system-logo-E7053CDC9F-seeklogo.com.png',
      },
      {
        name: 'Amazon S3',
        image: 'https://seeklogo.com/images/A/amazon-s3-simple-storage-service-logo-9A3F37976E-seeklogo.com.png',
      },
      {
        name: 'AWS Backup',
        image: 'https://d2908q01vomqb2.cloudfront.net/17ba0791499db908433b80f37c5fbc89b870084b/2023/05/10/Screenshot-2023-05-10-at-7.26.31-PM.png',
      },
      {
        name: 'KMS',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ1eMYmFn7kZ1TiskvzC7Vn-9Wf2XRHJaFjiA&s',
      },
      {
        name: 'CloudWatch',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmJWNXq74Q-5TP0-VGhxGhKiO6yCOx0LoGpw&s',
      },
    
      {
        name: 'API Gateway',
        image: 'https://raw.githubusercontent.com/pulumi/pulumi-aws-apigateway/main/assets/logo.png',
      },
      {
        name: 'Route 53',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQiMHJqSAbtbbt1SS9cQOTqW2XlhIjlAtEGew&s',
      },
      {
        name: 'Amazon ALB - ELB',
        image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ47Ji1yhUawSLNBXPp8UERlP7nKo3d1f2EKw&s',
      },
      {
        name: 'Amazon BeanStalk',
        image: 'https://seeklogo.com/images/A/aws-elastic-beanstalk-logo-BA204C47D0-seeklogo.com.png',
      },

    ],
  },
 
  {
    title: 'Services & Operating Systems',
    skills: [
      {
        name: 'Nginx',
        image:'https://static-00.iconduck.com/assets.00/file-type-nginx-icon-1793x2048-yt5u3fm7.png',
      },
      {
        name: 'Tomcat',
        image:'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fe/Apache_Tomcat_logo.svg/2560px-Apache_Tomcat_logo.svg.png',
        },
      {
      name: 'RabbitMq',
      image:'https://static-00.iconduck.com/assets.00/rabbitmq-icon-484x512-s9lfaapn.png',
      },
      {
        name: 'MencacheD',
        image: 'https://vmssoftware.com/images/intro/product/memcached.png',
      },
      {
        name: 'MySQL',
        image: 'https://pngimg.com/uploads/mysql/mysql_PNG23.png',
      },
      {
        name: 'Ubuntu',
        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/9e/UbuntuCoF.svg/2048px-UbuntuCoF.svg.png',
      },
      {
        name: 'Centos OS',
        image: 'https://cdn.freebiesupply.com/logos/large/2x/centos-1-logo-png-transparent.png',
      },
      {
        name: 'Kali Linux',
        image: 'https://seeklogo.com/images/K/kali-linux-logo-AED181186E-seeklogo.com.png',
      },
      {
        name: 'Windows',
        image: 'https://upload.wikimedia.org/wikipedia/commons/c/c2/Windows_11.png',
      },
    ],
  },

  
  {
    title: 'Web Development',
    skills: [
      {
        name: 'React Js',
        image: 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K',
      },
      {
        name: 'Redux',
        image: 'https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg',
      },
    
      {
        name: 'HTML',
        image: 'https://www.w3.org/html/logo/badge/html5-badge-h-solo.png',
      },
      {
        name: 'CSS',
        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png',
      },
      {
        name: 'JavaScript',
        image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png',
      },
      {
        name: 'Bootstrap',
        image: 'https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png',
      },
 
      {
        name: 'Node Js',
        image: 'https://nodejs.org/static/images/logo.svg',
      },
  
      {
        name: 'Spring Boot ',
        image: 'https://vscjava.gallerycdn.vsassets.io/extensions/vscjava/vscode-spring-boot-dashboard/0.13.2023072200/1689984300042/Microsoft.VisualStudio.Services.Icons.Default',
      },
      {
        name: 'Java',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg',
      },
 
      {
        name: 'MongoDB',
        image: 'https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg',
      },

    ],
  },
 

]

export const experiences = [
  {
    id: 0,
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqPX9JMLXMRjFBjwwjvvFSmW2r107L35TtYg&s',
    role: 'Cybersecurity Engineering Apprentice ',
    company: 'INSA CVL',
    date: 'November 2024 - Present',
    desc: 'Deployment of a private OpenStack cloud, covering all layers of the OSI model. Implementation (development phase) of an automated Security Operations Center (SOC), integrating SIEM tools such as Wazuh, TheHive, VirusTotal, and Shuffle. ',
    skills: ['Openstack', 'Terraform', 'Wazuh', 'Thehive', 'Opensense', "VirusTotal", "Shuffle","Networking","Vlans" ],
    doc: "",
  },
  {
    id: 1,
    img: 'https://media.licdn.com/dms/image/C560BAQHFIzvry0mKAw/company-logo_200_200/0/1630640710152/it_peac_logo?e=2147483647&v=beta&t=Y59OSnvFs9eAX149CYT598PNB6cnnYfcPLyHlAEE1Q8',
    role: 'DevSecOps Intern',
    company: 'IT.PEAC',
    date: 'February-July 2024',
    desc: 'Automated Deployment of infrastructure on AWS Clou - Automated database migration - Design and implementation of CI/CD pipelines - Improving Security and Compliance of AWS Cloud Infrastructure (Identity and Access Management, Data encryption and backup, Monitoring and Logging and Network Access Control. ',
    skills: ['AWS Cloud services', 'Terraform', 'Nexus', 'Postgresql ', 'CI/CD', "Bitbucket", "Jira", "Docker"],
    doc: "",
  },
  {
    id: 2,
    img: 'https://res.cloudinary.com/paypos/image/upload/v1695244951/proxyym_uha3wb.png',
    role: 'MERN stack Devoloper-OCR solution integrator  Intern',
    company: 'Proxym Group',
    date: 'July-August 2023',
    desc: 'Development and integration of a MERN stack banking  application enabling a credit request with National Identity card data extraction implementing the  OCR technique.',
    skills: ['Image preprocessing', 'python-Flask API', 'React Js', 'node Js ', 'Mongo db'],
    doc: "",
  },
  {
    id: 3,
    img: 'https://res.cloudinary.com/paypos/image/upload/v1695245286/paypos_i8gi8y.png',
    role: 'Node.js Developer intern',
    company: 'PayPos',
    date: 'july 2022',
    desc: 'Design and development of a backend API using Node.JS enviornment and Express Framework for an e-commerce website in collaboration with a React.js developer',
    skills: ['JavaScript', 'Node js', 'Express js', 'Mongo DB'],
    doc: ''
  },
  {
    id: 4,
    img: 'https://upload.wikimedia.org/wikipedia/fr/f/f9/LOGO_TT_.jpg',
    role: 'Tunsie Telecom Intern  ',
    company: 'Tunisie Telecom',
    date: 'June 2022',
    desc: "Internship as a technician, involving supply of high and medium speed internet to Tunisia Telecom customers. Tasks included handling of fiber optic cables and training on mobile networks such as 2G-3G-4G-5G",
    skills: ['Optical Fiber', 'Networking', 'Severs ', 'Routers', 'Switches'],
  },
 
]

export const education = [
  {
    id: 0,
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSqPX9JMLXMRjFBjwwjvvFSmW2r107L35TtYg&s',
    school: "National Institute of Applied Science (INSA CVL)" ,
    date: 'sep 2024',
    grade: 'Cyber security Engineering studies  ',
  },
  {
    id: 1,
    img: 'https://res.cloudinary.com/paypos/image/upload/v1689260553/Safta-Portfolio/enetcom_zyuykb.png',
    school: "National School of Electronics and Telecoms of Sfax (ENET'Com)" ,
    date: 'sep 2021 - Sep 2024',
    grade: 'National Degree in ICT Engineering',
    desc: "",
    // degree: 'Bachelor of Technology - BTech, Computer Science and Engineering',
  },
  {
    id: 2,
    img: 'https://ipeim.rnu.tn/useruploads/files/logo_face_book.jpg',
    school: 'Monastir Preparatory Engineering Institute',
    date: 'Apr 2019 - Apr 2025',
    grade: ' Engineering Preparatory Cycle Degree',
    desc: "I have successfully completed two years of scientific preparatory studies, specializing in the PC (Physics-Chemistry) section, where I have gained notable mathemaatical, physical  and chemistry fundemantals ",
    degree: '',
  },
  {
    id: 3,
    img: 'https://res.cloudinary.com/paypos/image/upload/v1689329629/Safta-Portfolio/ljf_qotq0n.jpg',
    school: 'Tahar Sfar Sousse High School (LJF)',
    date: 'sep 2015 - Jul 2019',
    grade: 'Bachelor Degree in Expeimental Sciences',
    desc: " I have completed my secondary education in the LJF college and obtained the National Bachelor Degree.",
    degree: '',
  },
]
export const projects = [

  {
    id: 11,
    title: ' CI Project : Continuous integration with Jenkins and  tools',
    date: 'November 2023',
    description: "The project aims to create an automated process for code build test and commit using Jenkins as a  main continuous integration tool, Nexus for storing artifacts and dependencies , SonaQube for continous code test and inspection.The project also integrates Slack to notify developers about every build status.",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1702868597/ezgif.com-speed_qoqfuu.gif',
    tags: ['Jenkins','Git','Nexus Sonatype','SonarQube','CheckStyle','Gihub WebHooks','Slack notifier'],
    category: 'Devops project',
    github: '',
    link: 'https://www.linkedin.com/posts/ahmed-safta-094a6321a_continuous-integration-with-jenkins-activity-7130495518157230080-xGUr?utm_source=share&utm_medium=member_desktop&rcm=ACoAADdUUrAB-tEkePefO-DTTx8a8ceQeIm6upo',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: 'www.linkedin.com/in/safta-ahmed-094a6321a',
        github: 'https://github.com/AhmedSafta71',
      },
  
    ]
  },



  {
    id: 10,
    title: ' AWS Project : lift & shift application workload ',
    date: 'July 2023',
    description: "The project aims to migrate a web application worklod running on local server to the cloud using amazon web services: Elastic load balancers (ELB),EC2 instances,Route53 S3 bucket,IAM. ",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1695164939/ezgif.com-gif-maker_2_qngtcq.gif',
    tags: ['AWS','EC2','Security groups ','Route53','IAM','S3 bucket','Auto scaling groups','NameCheap Domain name',"Certificate Authority" ,'IAAS','PayAsUgo',"Automation"],
    category: 'Devops project',
    github: '',
    link: 'https://www.linkedin.com/posts/ahmed-safta-094a6321a_aws-project-lift-shift-application-workload-activity-7097325092992360449-U730?utm_source=share&utm_medium=member_desktop&rcm=ACoAADdUUrAB-tEkePefO-DTTx8a8ceQeIm6upo',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: 'www.linkedin.com/in/safta-ahmed-094a6321a',
        github: 'https://github.com/AhmedSafta71',
      },
  
    ]
  },
 
 
  {
    id: 3,
    title: 'NASA App',
    date: 'June -July 2023',
    description: "I developed a Node API and connected it with  NASA web application made with React js and deploy it using Docker containers  and AWS ",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1689628738/ezgif.com-gif-maker_1_t3eyij.gif',
    tags: ['React Js', 'Arwes', 'Node js', 'Mongo DB', 'Docker','CI/CD','AWS ECS'],
    category: 'web App',
    github: 'https://github.com/AhmedSafta71/NASA-App',
    webapp: '',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: 'www.linkedin.com/in/safta-ahmed-094a6321a',
        github: 'https://github.com/AhmedSafta71'
      },
  
    ]
  },

  {
    id: 0,
    title: 'Spring TODO-List Platform',
    date: 'July 2023',
    description: "Academic Spring Boot application developed as part of the in28minutes famous Udemy course. The project aims to enhance understanding of the MVC architecture, handling JSP files, practicing CRUD operations, and implementing Spring Boot Security framework for authentication.",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1689259966/Safta-Portfolio/Capture_d_%C3%A9cran_2023-07-12_165024_ccmiz4.png',
    tags:  ['Spring Boot', 'Java', 'JSP', 'H2 Database', 'Spring Security'],
    category: 'web app',
    github: 'https://github.com/AhmedSafta71/Spring_toDoList_App',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: "www.linkedin.com/in/safta-ahmed-094a6321a",
        github: 'https://github.com/AhmedSafta71'
      },
   
    ]
  },
  {
    id: 8, 
    title: 'Login password cracking',
    date: 'Jan 2021',
    description: "In the context of this project, I chose a vulnerable web page (Mutillidae) from the Metasploitable machine to crack the authentication password. To intercept the traffic, I used the Burp Suite software. Once the desired data has been collected, we will carry out the brute force attack using the Hydra tool.",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1689375677/ezgif.com-video-to-gif_3_okn4au.gif',
    tags: ['Kali Linux', 'hydra ', 'Metasploitable', 'Mutillidae', 'Mimikatz', 'Burpsuite'],
    category: 'Security project',
    github: 'https://github.com/AhmedSafta71',
    webapp: '',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: "www.linkedin.com/in/safta-ahmed-094a6321a",
        github: 'https://github.com/AhmedSafta71'
      },
   
    ]
  },

  {
    id: 1,
    title: 'DoctoChat-End of Year Project',
    date: 'Jan 2023 - Jun 2023',
    description: "The DoctoChat application is a web application open to private doctors sector in Tunisia as well as to regular users. The application offers, on one hand, an advertising approach todoctors who own medical practices. On the other hand, the platform allows authenticated users to monitor their health status through a secure patient-doctor messaging service.Responses are provided by reliable and active healthcare experts on the site. The number of responses and their relevance level are determining factors for distinguishing doctors.",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1689347728/PFA_images/Capture_d_%C3%A9cran_2023-07-14_171003_nwij1t.png',
    tags: ['React js','Redux', 'Bootstrap 5','Node.js','Express.js', 'Mongo DB', 'OAuth2','Stripe API','Axios'],
    category: 'web app',
    github: 'https://github.com/AhmedSafta71/PFA_Medical_App_Front-End',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: 'www.linkedin.com/in/safta-ahmed-094a6321a',
        github: 'https://github.com/AhmedSafta71'
      },
  
    ]
  },

  {
    id: 4,
    title: 'Guess My Number Game',
    date: 'october 2022',
    description: "Guess My number is a funny interactive game made with html5 and javaScript." ,
    image: 'https://res.cloudinary.com/paypos/image/upload/v1689365268/Safta-Portfolio/ezgif.com-video-to-gif_1_hmf8iy.gif',
    tags: ['JavaScript','HTML5'],
    category: 'web app',
    github: '',
    link:'',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: "www.linkedin.com/in/safta-ahmed-094a6321a",
        github: 'https://github.com/AhmedSafta71'
      },
   
    ]
  },
  {
    id: 5,
    title: 'The Ninja Book',
    date: 'Jun 2022',
    description: "Single web page made with html and bootstrap made as part of a bootstrap tutorial ",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1689360773/Safta-Portfolio/ezgif.com-video-to-gif_opfdfp.gif',
    tags: ['HTML5', 'Bootstrap5'],
    category: 'web app',
    github: '',
    webapp: '',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: "www.linkedin.com/in/safta-ahmed-094a6321a",
        github: 'https://github.com/AhmedSafta71'
      },
   
    ]
  },
  {
    id: 6,
    title: 'Snort IDS Project',
    date: 'Apr 2023',
    description: "The Snort IDS Project(Intrusion Detection System) is an exemplary presentation that explores the functional modes of Snort IDS, elucidating its mechanisms of operation. It meticulously discusses the optimal positioning of Snort IDS within a network and provides insightful examples that demonstrate the effective implementation of Snort rules.",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1689367080/ezgif.com-video-to-gif_2_zleyxu.gif',
    tags: ['Network Security', 'Snort IDS'],
    category: 'Security project',
    github: '',
    webapp: '',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: "www.linkedin.com/in/safta-ahmed-094a6321a",
        github: 'https://github.com/AhmedSafta71'
      },
   
    ]
  },
  {
    id: 7,
    title: 'Zip files Password cracking Scenario',
    date: ' nov 2022',
    description: "In This scenario we will capture the password hashes of the zip files and then attempt to find the password that corresponds to each hash using the Kali linux tool John the Ripper.",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1689373216/ezgif.com-gif-maker_vvcwft.gif',
    tags: ['Kali Linux', 'John the Ripper'],
    category: 'Security project',
    github: '',
    webapp: '',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: "www.linkedin.com/in/safta-ahmed-094a6321a",
        github: 'https://github.com/AhmedSafta71'
      },
   
    ]
  },
  
  {
    id: 9,
    title: 'Multi tier web app workload ',
    date: 'July 2023',
    description: "Created and provisioned virtual machines (VMs), configured services including NGINX, Memcached, RabbitMQ, and MySQL. Developed a Java application and deployed the artifact on a virtual machine running Tomcat.",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1695165418/ezgif.com-gif-maker_3_alsrtc.gif',
    tags: ['Virtual machines','Vagrant', 'NGINX','TOMCAT','RabbitMQ', 'MEMCACHED', 'MYSQL','Java app'],
    category: 'Devops project',
    github: '',
    link: 'https://www.linkedin.com/posts/ahmed-safta-094a6321a_devops-virtualisation-automation-activity-7089678405935190016-UohA?utm_source=share&utm_medium=member_desktop&rcm=ACoAADdUUrAB-tEkePefO-DTTx8a8ceQeIm6upo',
    member: [
      {
        name: 'Ahmed Safta',
        img: 'https://res.cloudinary.com/paypos/image/upload/v1689259782/Safta-Portfolio/cv_cznnz9.png',
        linkedin: 'www.linkedin.com/in/safta-ahmed-094a6321a',
        github: 'https://github.com/AhmedSafta71'
      },
  
    ]
  },
 

]

export const articles = [

  {
    id: 0,
    title: ' Openstack installtion Troubleshooting',
    date: 'Feburary 2025',
    description: "In this post, I covered the absolute basics of TLS/SSL certificates — what they are, why we need them, and how they efficiently secure our web servers.",
    image: 'https://www.logo.wine/a/logo/OpenStack/OpenStack-Logo.wine.svg',
    tags: ['Openstack','Troubleshooting','Private-cloud','Centos-os','Caracal'],
    category: 'Openstack',
    link: 'https://medium.com/@ahmedsafta71/openstack-troubleshooting-a-deep-dive-into-manual-installation-isssues-68ba40b0c63a'
  },



  {
    id: 1,
    title: 'Understanding TLS Certificates: Securing Your Web Traffic Against Cyber Attacks',
    date: 'September 2024',
    description: "In this post, I covered the absolute basics of TLS/SSL certificates — what they are, why we need them, and how they efficiently secure our web servers.",
    image: 'https://miro.medium.com/v2/resize:fit:720/format:webp/1*Bx1UzBcobud-LSTEQsIxmg.gif',
    tags: ['"TLS/SSL certificates','Cybersecurity','Web traffic','Certificate Authority'],
    category: 'Cybersecurity',
    link: 'https://medium.com/@ahmedsafta71/understanding-tls-certificates-securing-your-web-traffic-against-cyber-attacks-293009320160'
 
  },
 
  {
    id: 2,
    title: 'Why I Chose AWS Step Functions Over Lambda: A Deep Dive Through a Real Use Case',
    date: 'August 2024',
    description: "In this post, I covered the absolute basics of TLS/SSL certificates — what they are, why we need them, and how they efficiently secure our web servers.",
    image: 'https://res.cloudinary.com/paypos/image/upload/v1740349297/58ae5174-cc61-46b3-9559-8dcd74a94d45.png',
    tags: ['AWS','Lambdafunction','Step functions'],
    category: 'AWS',
    link: 'https://medium.com/@ahmedsafta71/why-i-chose-aws-step-functions-over-lambda-a-deep-dive-through-a-real-use-case-fcae97930062',
  
  },




 
 

];

export const TimeLineData = [
  { year: 2019, text: 'Earned Baccalaureate Exam Diploma.' },
  { year: 2020 ,text: 'Scientific Preparatory studies for engineers' },
  { year: 2021, text: 'Earned Scientic Preparatory Studies for engineers Diploma '},
  { year: 2022, text: 'Starting my journey to become a telecommunictaion Engineer', },
  { year: 2024, text: 'Earned Engineering Telecommunication Diploma', },
  { year: 2024, text: 'Starting my journey to specialize in Cybersecurity at INSA CVL Engineering school', },
];
